﻿import React, {FC} from 'react';
import {
  CollapsableCardBodyItemContainer,
  CollapsableCardLabel,
  CollapsableCardValue
} from "@securspace/securspace-ui-kit";
import {SlotType} from "../../types/Slots";
import {useSlotOrDefault} from "../../hooks/slots/useSlotOrDefault";

type CollapsableCardBodyItemProps = React.ComponentPropsWithoutRef<'div'> & {
  value: SlotType;
  label: SlotType;
}

const CollapsableCardBodyItem: FC<CollapsableCardBodyItemProps> = ({ value, label, ...rest}) => {
  const Label = useSlotOrDefault(label, CollapsableCardLabel);
  const Value = useSlotOrDefault(value ?? '-', CollapsableCardValue);

  return <CollapsableCardBodyItemContainer {...rest}>
    {Label}
    {Value}
  </CollapsableCardBodyItemContainer>
}

export { CollapsableCardBodyItem };
